/*
 * @Author: bbqin
 * @Date: 2021-12-09 14:27:54
 * @LastEditTime: 2021-12-13 16:43:10
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\base\Grid\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Row as OriginRow } from 'bee-layout';
// import { Col as OriginCol } from 'bee-layout';
import { Col as OriginCol, Row as OriginRow } from '@tinper/next-ui';
import { getSysFieldid } from '@platform/api';

//require('bee-layout/build/Layout.css');
require('./index.less');

// 网格组件
class Grid extends Component {

    static defaultProps = {
        grid: false,
        className: '',
        gap: 'normal',
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { children, gap, style, grid, className, fieldid, ...others } = this.props;
        if (grid) {
            return <div
                className='grid-container'
                style={{
                    gap: gap,
                    ...style,
                }}
            >{children}</div>;
        }
        return <OriginRow
            {...others}
            fieldid={getSysFieldid(fieldid)}
            className={classNames('grid-container', className)}
        >{children}</OriginRow>;
    }
}

const propTypes = {
    componentClass: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),

    /**
     * xs显示列数
     */
    xs: PropTypes.number,
    /**
     * sm显示列数
     */
    sm: PropTypes.number,
    /**
     * md显示列数
     */
    md: PropTypes.number,
    /**
     * lg显示列数
     */
    lg: PropTypes.number,
    /**
     * xs偏移列数
     */
    xsOffset: PropTypes.number,
    /**
     * sm偏移列数
     */
    smOffset: PropTypes.number,
    /**
     * md偏移列数
     */
    mdOffset: PropTypes.number,
    /**
     * lg偏移列数
     */
    lgOffset: PropTypes.number,
    /**
     * xs右偏移列数
     */
    xsPush: PropTypes.number,
    /**
     * sm右偏移列数
     */
    smPush: PropTypes.number,
    /**
     * md右偏移列数
     */
    mdPush: PropTypes.number,
    /**
     * lg右偏移列数
     */
    lgPush: PropTypes.number,
    /**
     * xs左偏移列数
     */
    xsPull: PropTypes.number,
    /**
     * sm左偏移列数
     */
    smPull: PropTypes.number,
    /**
     * md左偏移列数
     */
    mdPull: PropTypes.number,
    /**
     * lg左偏移列数
     */
    lgPull: PropTypes.number,
    /**
     * 网格模式
     */
    grid: PropTypes.Boolean,

};

const defaultProps = {
    componentClass: 'div',
    grid: true,
};

// 单元格组件
class Cell extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { children, row = 'auto', col = 'auto', offset = 'auto', style, grid, className, ...others } = this.props;
        let gridArea = `span ${row}/span ${col}/auto/${isNaN(col) || isNaN(offset) || offset == '1' ? 'auto' : Number(col) + Number(offset)}`;

        if (grid) {
            return <div
                className='grid-cell'
                style={{
                    gridArea: gridArea,
                    ...style,
                }}
            >{children}</div>;
        }

        return <OriginCol
            {...others}
            className={classNames('grid-cell', className)}
        >{children}</OriginCol>;
    }
}

Cell.defaultProps = defaultProps;
Cell.propTypes = propTypes;

Grid.Cell = Cell;

export default Grid;